<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加门店-->
      <div class="common-form">修改物流公司</div>
      <el-form-item label="物流公司名称 ">
        <el-input v-model="form.express_name" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="物流公司代码(快递100) " prop="express_code" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.express_code" class="max-w460"></el-input>
        <div class="tips">用于快递100API查询物流信息，务必填写正确;请对照
          <el-link type="primary" :underline="false" @click="gotoCompany(0)">
            快递100物流公司编码表
          </el-link>
          填写
        </div>
      </el-form-item>
      <el-form-item label="物流公司代码(快递鸟) " prop="kdniao_express_code" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.kdniao_express_code" class="max-w460"></el-input>
        <div class="tips">用于快递鸟API查询物流信息，务必填写正确;请对照
          <el-link type="primary" :underline="false" @click="gotoCompany(1)">
            快递鸟物流公司编码表
          </el-link>
          填写
        </div>
      </el-form-item>
       <el-form-item label="物流公司代码(快递助手) " prop="kdzs_express_code" >
        <el-input v-model="form.kdzs_express_code" class="max-w460"></el-input>
        <div class="tips">请填写正确的快递公司编码,<el-link :underline="false" href="https://open.kdzs.com/document/basic?catId=7&id=4" target="_blank"
              type="primary">查看快递公司编码</el-link>
          </div>
      </el-form-item>
	  <el-form-item label="物流公司代码(微信) " prop="weixin_express_code">
	    <el-input v-model="form.weixin_express_code" class="max-w460"></el-input>
	    <div class="tips">用于微信API查询物流信息，务必填写正确;请对照
	      <el-link type="primary" :underline="false" @click="gotoWxCompany()">
	        微信物流公司编码表
	      </el-link>
	      填写
	    </div>
	  </el-form-item>
      <el-form-item label="排序">
        <el-input v-model="form.sort" type="number" class="max-w460"></el-input>
        <div class="tips">数字越小越靠前</div>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper"><el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';

export default {
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        express_id: '',
        express_name: '',
        express_code: '',
        kdniao_express_code: '',
        kdzs_express_code: '',
		weixin_express_code: '',
        sort: ''
      },
      loading: false
    };
  },
  created() {
    this.getData();
  },

  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.$route.query.express_id;
      SettingApi.expressDetail(
        {
          express_id: params
        },
        true
      )
        .then(data => {
          let detail = data.data.detail;
          // 将数据放在当前组件的数据内
          self.form.express_id = detail.express_id;
          self.form.express_name = detail.express_name;
          self.form.express_code = detail.express_code;
          self.form.kdniao_express_code = detail.kdniao_express_code;
		  self.form.weixin_express_code = detail.weixin_express_code;
          self.form.sort = detail.sort;
        })
        .catch(error => {});
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.editExpress(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，修改成功',
            type: 'success'
          });
          self.$router.push('/setting/express/index');
        })
        .catch(error => {
          self.loading = false;
        });
    },
	
	gotoWxCompany(){
	  let baseUrl = window.location.protocol + '//' + window.location.host;
	  window.location.href = baseUrl + '/wx_express.xlsx';
	},

    /*跳转物流编码*/
     gotoCompany(type=0) {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        if(type ==0){
          window.location.href = baseUrl + '/express.xlsx';
        }else{
          window.location.href = baseUrl + '/kdniaoexpress.xlsx';
        }
        
      }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/express/edit.vue